import React from 'react';
import { Text } from '@makemydeal/dr-ui-bricks-components';
import type { CustomerDetails } from '@makemydeal/dr-sales-checkin-types';

import { PageHeader } from '../PageHeader/PageHeader';
import { ShowroomCardContainer } from '../Showroom/showroom.style';
import { CustomerDetailsSummary } from '../CustomerDetailsSummary/CustomerDetailsSummary';
import { ShareCreditAppLink } from '../ShareCreditAppLink/ShareCreditAppLink';
import { ShareCreditAppQrCode } from '../ShareCreditAppQrCode/ShareCreditAppQrCode';
import { CUSTOMER_DETAILS_LABELS } from './constants';
import { CustomerDetailsShareOptions, CustomerDetailsDivider, CustomerDetailsSectionRoot } from './customerDetailsView.style';

export const CustomerDetailsView: React.FC<{ customerDetails: CustomerDetails }> = ({ customerDetails }) => (
    <ShowroomCardContainer>
        <CustomerDetailsSectionRoot data-testid="customer-details-section">
            <PageHeader isResponsive heading={customerDetails.title} />
            {!customerDetails.isCreditAppSubmitted && (
                <Text data-testid="customer-details-prompt">{CUSTOMER_DETAILS_LABELS.prompt}</Text>
            )}
            <CustomerDetailsSummary
                customerName={customerDetails.buyerFullName}
                email={customerDetails.buyerEmail}
                onEdit={customerDetails.onEdit}
            />
            {!customerDetails.isCreditAppSubmitted && (
                <>
                    <CustomerDetailsDivider data-testid="customer-details-divider">
                        <Text as="span" size="xsmall">
                            {CUSTOMER_DETAILS_LABELS.otherWaysLabel}
                        </Text>
                    </CustomerDetailsDivider>
                    <CustomerDetailsShareOptions>
                        <ShareCreditAppLink buyerFirstName={customerDetails.buyerFirstName} onSend={customerDetails.onSendLink} />
                        <ShareCreditAppQrCode
                            buyerFirstName={customerDetails.buyerFirstName}
                            link={customerDetails.creditAppLink}
                        />
                    </CustomerDetailsShareOptions>
                </>
            )}
        </CustomerDetailsSectionRoot>
    </ShowroomCardContainer>
);
